import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
            labels: {
                boxWidth: 10,
                boxHeight: 10,
                borderRadius: 3,
                useBorderRadius: true,
                font: { size: 12 },
                color: '#6b7280',
            },
        },
        tooltip: {
            backgroundColor: '#1e3a6e',
            titleFont: { size: 12 },
            bodyFont: { size: 12 },
            padding: 10,
            cornerRadius: 8,
        },
    },
    scales: {
        x: {
            grid: { display: false },
            ticks: { color: '#9ca3af', font: { size: 11 } },
        },
        y: {
            beginAtZero: true,
            grid: { color: '#f3f4f6', drawBorder: false },
            ticks: { color: '#9ca3af', font: { size: 11 } },
        },
    },
    borderRadius: 4,
    borderSkipped: 'bottom',
};

function Chart({ yearDisbursed, yearRepaid }) {
    const data = {
        labels,
        datasets: [
            {
                label: 'Disbursement',
                data: yearDisbursed,
                backgroundColor: 'rgba(30, 58, 110, 0.85)',
                borderWidth: 0,
                borderRadius: 4,
            },
            {
                label: 'Repayment',
                data: yearRepaid,
                backgroundColor: 'rgba(16, 185, 129, 0.85)',
                borderWidth: 0,
                borderRadius: 4,
            },
        ],
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5">
            <div className="mb-4">
                <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Disbursements vs Repayments</p>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Year-to-date breakdown by month</p>
            </div>
            <div className="h-72">
                <Bar options={options} data={data} />
            </div>
        </div>
    );
}

export default Chart;
